module.exports = __webpack_public_path__ + "static/media/heart-outline-white.7a85453c.png";